import { render, staticRenderFns } from "./v15-config.vue?vue&type=template&id=7fab1e8b&scoped=true"
import script from "./v15-config.vue?vue&type=script&lang=ts"
export * from "./v15-config.vue?vue&type=script&lang=ts"
import style0 from "./v15-config.vue?vue&type=style&index=0&id=7fab1e8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab1e8b",
  null
  
)

export default component.exports